import React from "react";
// import both from "../assets/img/both.png";
// import rowena from "../assets/img/rowena.png";
import { Subscribe } from "./Subscribe";
import { Gallery } from "./Gallery";

import nsw1 from "../assets/img/screenshots-nsw/1.png";
import nsw2 from "../assets/img/screenshots-nsw/2.png";
import nsw3 from "../assets/img/screenshots-nsw/3.png";
import nsw4 from "../assets/img/screenshots-nsw/4.png";
import nsw5 from "../assets/img/screenshots-nsw/5.png";
import nsw6 from "../assets/img/screenshots-nsw/6.png";
import nsw7 from "../assets/img/screenshots-nsw/7.png";
import nsw8 from "../assets/img/screenshots-nsw/8.png";

import YouTube from "react-youtube";
import track from "./Track";
import { Story } from "./Story";
import { Characters } from "./Characters";
import { ProductInfo } from "./ProductInfo";
import { Exemplars } from "./Exemplars";
import { Wallpapers } from "./Wallpapers";

import blue from "../style/blue.jpg";
import crimson from "../style/crimson.jpg";

const nsw = [nsw1, nsw2, nsw3, nsw4, nsw5, nsw6, nsw7, nsw8];

const SNS = ["tFeoCunTNZg", "ZY-HyCJjUpg", "XkTjBWju2XI", "n4mDLDzt5zA"];

export const Content = () => {
  const [hovered, setHovered] = React.useState(false);
  const [videoWidth, setVideoWidth] = React.useState(40);

  // const opts = {
  //     height: `56%`,
  //     width: `100%`,

  //   };

  React.useEffect(() => {
    if (window.innerWidth < 1000) {
      setVideoWidth(40);
    }
    window.addEventListener("resize", (d) => {
      if (d.currentTarget.innerWidth < 1000) {
        setVideoWidth(40);
      } else {
        setVideoWidth(40);
      }
    });
  }, []);
  return (
    <div id="content" className="page flex">
      <Story />
      <Characters />
      <Exemplars />

      <div className="video-container" style={{ margin: "0 0" }} id="trailers">
        {/* <div className="overlay" style={{width:`${videoWidth}vw`, height:`${videoWidth * .5625}vw`, backgroundColor:'black', position:'absolute', pointerEvents:hovered?"none":"initial", cursor:'pointer', opacity:hovered?0:.6, transition:videoWidth===90?"none":'1s ease-in'}} onMouseEnter={()=>setHovered(true)}></div> */}

        <h2 className="font1 catch" style={{ color: "white" }}>
          Trailers
        </h2>
        <div className="flex row wrap">
          <div
            className="video flex"
            style={
              {
                // width: `${videoWidth}vw`,
                // , height:`${videoWidth * .5625}vw`
              }
            }
          >
            {/* <div className="vid" style={{position:'absolute', backgroundColor:'blue', zIndex:2, width:'50%', height:'50%', opacity:.5, pointerEvents:'none'}}></div> */}
            <YouTube
              videoId="4x-XmzM9iwk"
              onPlay={() => track("Trailer1")}
              className="vid"
            />
          </div>
          <div
            className="video flex"
            style={
              {
                // width: `${videoWidth}vw`,
                // , height:`${videoWidth * .5625}vw`
              }
            }
          >
            {/* <div className="vid" style={{position:'absolute', backgroundColor:'blue', zIndex:2, width:'50%', height:'50%', opacity:.5, pointerEvents:'none'}}></div> */}
            <YouTube
              videoId="bYLR3N7IYu8"
              onPlay={() => track("Trailer2")}
              className="vid"
            />
          </div>
          <div
            className="video flex"
            style={
              {
                // width: `${videoWidth}vw`,
                // , height:`${videoWidth * .5625}vw`
              }
            }
          >
            {/* <div className="vid" style={{position:'absolute', backgroundColor:'blue', zIndex:2, width:'50%', height:'50%', opacity:.5, pointerEvents:'none'}}></div> */}
            <YouTube
              videoId="hZzCZQIBcdo"
              onPlay={() => track("Trailer3")}
              className="vid"
            />
          </div>
        </div>
        <div className="flex row wrap">
          <div
            className="video flex"
            style={
              {
                // width: `${videoWidth}vw`,
                // , height:`${videoWidth * .5625}vw`
              }
            }
          >
            {/* <div className="vid" style={{position:'absolute', backgroundColor:'blue', zIndex:2, width:'50%', height:'50%', opacity:.5, pointerEvents:'none'}}></div> */}
            <YouTube
              videoId={SNS[0]}
              onPlay={() => track("Exemplar Clip 1")}
              className="vid"
            />
          </div>
          <div
            className="video flex"
            style={
              {
                // width: `${videoWidth}vw`,
                // , height:`${videoWidth * .5625}vw`
              }
            }
          >
            {/* <div className="vid" style={{position:'absolute', backgroundColor:'blue', zIndex:2, width:'50%', height:'50%', opacity:.5, pointerEvents:'none'}}></div> */}
            <YouTube
              videoId={SNS[1]}
              onPlay={() => track("Exemplar Clip 2")}
              className="vid"
            />
          </div>
          <div
            className="video flex"
            style={
              {
                // width: `${videoWidth}vw`,
                // , height:`${videoWidth * .5625}vw`
              }
            }
          >
            {/* <div className="vid" style={{position:'absolute', backgroundColor:'blue', zIndex:2, width:'50%', height:'50%', opacity:.5, pointerEvents:'none'}}></div> */}
            <YouTube
              videoId={SNS[2]}
              onPlay={() => track("Exemplar Clip 3")}
              className="vid"
            />
          </div>
          <div
            className="video flex"
            style={
              {
                // width: `${videoWidth}vw`,
                // , height:`${videoWidth * .5625}vw`
              }
            }
          >
            {/* <div className="vid" style={{position:'absolute', backgroundColor:'blue', zIndex:2, width:'50%', height:'50%', opacity:.5, pointerEvents:'none'}}></div> */}
            <YouTube
              videoId={SNS[3]}
              onPlay={() => track("Exemplar Clip 4")}
              className="vid"
            />
          </div>
        </div>
      </div>

      {/* <h2 className="font1 catch" style={{color:'white'}}>PS4&trade; Screenshots</h2>
            <Gallery arr={ps4}/> */}
      <h2 className="font1 catch" style={{ color: "white" }} id="screenshots">
        Screenshots
      </h2>
      <Gallery arr={nsw} />
      <Wallpapers />
      <DLC />
      <ProductInfo />

      <h2
        className="font1 bold glow"
        style={{ color: "white", fontFamily: "font1" }}
      >
        Subscribe to get the latest information
      </h2>
      {socials}
      <Subscribe btn={"sub"} input={"email-input"} />
    </div>
  );
};

const socials = (
  <div className="social-media flex row wrap">
    <a
      href="https://twitter.com/nisamerica"
      target="_blank"
      className="track-link"
      data-label="Twitter"
    >
      <i className="fab fa-twitter btn"></i>
    </a>

    <a
      href="https://www.facebook.com/NISAmericaInc/"
      target="_blank"
      className="track-link"
      data-label="Facebook"
    >
      <i className="fab fa-facebook-f btn"></i>
    </a>

    <a
      href="https://www.instagram.com/nisamerica/"
      target="_blank"
      className="track-link"
      data-label="Instagram"
    >
      <i className="fab fa-instagram btn"></i>
    </a>

    <a
      href="https://www.youtube.com/user/NISAmerica"
      target="_blank"
      className="track-link"
      data-label="YouTube"
    >
      <i className="fab fa-youtube btn"></i>
    </a>

    <a
      href="https://www.twitch.tv/nisamerica"
      target="_blank"
      className="track-link"
      data-label="Twitch"
    >
      <i className="fab fa-twitch btn"></i>
    </a>

    <a
      href="https://discord.gg/nisa"
      target="_blank"
      className="track-link"
      data-label="Discord"
    >
      <i className="fab fa-discord btn"></i>
    </a>
  </div>
);

function DLC() {
  return (
    <>
      <div className="flex" id="dlc">
        <h1 className="chars-title">DLC</h1>
        {/* <h2>DLC</h2> */}
        <h2>BLAZBLUE EXEMPLAR COSTUME BUNDLE</h2>
        <img src={blue} alt="" />
        <p>
          Blaze into battle! With the new BlazBlue cosmetic DLC, your Exemplars
          can now take on the appearance of powerful fighters such as Ragna the
          Bloodedge, Noel Vermillion, and Jin Kisaragi. Decimate your enemies in
          style!
        </p>
        <div
          className="video flex"
          style={
            {
              // width: `${videoWidth}vw`,
              // , height:`${videoWidth * .5625}vw`
            }
          }
        >
          {/* <div className="vid" style={{position:'absolute', backgroundColor:'blue', zIndex:2, width:'50%', height:'50%', opacity:.5, pointerEvents:'none'}}></div> */}
          <YouTube
            videoId={"4xXDcDQ37_I"}
            onPlay={() => track("Trailer")}
            className="vid"
          />
        </div>
        <p>
          These DLC costumes are available for purchase now on the{" "}
          <a
            href="https://store.playstation.com/en-us/product/UP1063-CUSA23468_00-FLREVENANTS00001/"
            target="_blank"
          >
            PlayStation™️Store
          </a>{" "}
          and{" "}
          <a
            href="https://www.nintendo.com/games/detail/fallen-legion-revenants-switch/"
            target="_blank"
          >
            <span style={{ whiteSpace: "nowrap" }}>Nintendo eShop</span>
          </a>
          .
        </p>
        <h2>JAPANESE VOICEOVERS</h2>
        <p>
          A Japanese voice pack is now available! Update your game to get this
          FREE feature!
        </p>
        <h2>CRIMSON ROSE UPDATE</h2>
        <img src={crimson} alt="" />
        <p>
          Download the FREE Crimson Rose update to take your adventures to the
          next level.
        </p>
        <h2>This update includes the following features:</h2>
        <ul>
          <p>
            <li>
              <span style={{ color: "#7600bb", fontWeight: "bold" }}>
                Difficulty levels
              </span>{" "}
              – choose between story, challenge, and merciless mode to suit your
              play style! The game’s difficulty can be changed at any time.
            </li>
            <br />
            <li>
              <span style={{ color: "#7600bb", fontWeight: "bold" }}>
                Archeus Fusion system
              </span>{" "}
              – combine archeus together to enhance your characters with more
              powerful effects.
            </li>
            <br />
            <li>
              <span style={{ color: "#7600bb", fontWeight: "bold" }}>
                Rebalanced gameplay with retuned enemies and bosses
              </span>{" "}
              – fight foes with new attacks and experience rebalanced battles
              based on player feedback.
            </li>
            <br />
            <li>
              <span style={{ color: "#7600bb", fontWeight: "bold" }}>
                Quality of life improvements
              </span>{" "}
              – faster combat speed, a refined Inventory system with key item
              hints, additional tutorials, and more!
            </li>
            <br />
            <li>
              <span style={{ color: "#7600bb", fontWeight: "bold" }}>
                More deathblows
              </span>{" "}
              - 12 additional deathblows (1 per Exemplar) can be found in the
              game. Your relationships with characters in Welkin are the key to
              finding these secret items.
            </li>
            <br />
          </p>
        </ul>
      </div>
      {/* <div className="bg"></div> */}
    </>
  );
}
